import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SidebarComponent} from './sidebar.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {RouterModule} from '@angular/router';
import {InlineSVGModule} from 'ng-inline-svg';
import {IconsModule} from "../icons/icons.module";



@NgModule({
  declarations: [
    SidebarComponent,
  ],
  exports: [
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    CollapseModule,
    RouterModule,
    CollapseModule.forRoot(),
    InlineSVGModule,
    IconsModule
  ]
})
export class SidebarModule { }
